import moment from 'moment';

type DateFormatProps = {
  date: Date | string;
  defaultText?: string;
  className?: string;
  format?: string;
};

export const DATE_TIME_FORMAT = "MM/DD/YYYY hh:mm:ss A"

const DateFormat = (props: DateFormatProps) => {
  const { format, className, date, defaultText } = props

  return (
    <span className={className}>
      {moment(date).isValid()
        ? moment(date).format(format ?? 'MMM DD, YYYY')
        : defaultText
      }
    </span>
  )
}

export function convertToLocalTime(utcDate: string, formatString?: string) : string {
  const utcMoment = moment(utcDate.toUpperCase().endsWith('Z') ? utcDate : utcDate + 'Z');
  return utcMoment.isValid() ? utcMoment.local().format(formatString ?? DATE_TIME_FORMAT) : utcDate;
}

export default DateFormat;
